import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "textarea", "form" ]

  connect() {
    this.boundHandleKeydown = this.handleKeydown.bind(this);
    this.textareaTarget.addEventListener('keydown', this.boundHandleKeydown);
    
    // Prevent form submission on Enter key
    this.formTarget.addEventListener('keypress', (e) => {
      if (e.key === 'Enter' && !e.shiftKey) {
        e.preventDefault();
      }
    });
  }

  disconnect() {
    if (this.textareaTarget) {
      this.textareaTarget.removeEventListener('keydown', this.boundHandleKeydown);
    }
    this.boundHandleKeydown = null;
  }

  handleKeydown(event) {
    // Only handle Enter key events
    if (event.key !== 'Enter') return;
    
    if (event.shiftKey) {
      // Let the default behavior happen for Shift+Enter (new line)
      return;
    }
    
    // Prevent empty submissions
    if (!this.textareaTarget.value.trim()) {
      event.preventDefault();
      return;
    }
    
    // Handle regular Enter (form submission)
    event.preventDefault(); // Prevent default Enter behavior
    if (this.hasFormTarget) {
      const submitButton = this.formTarget.querySelector('input[type="submit"], button[type="submit"]');
      if (typeof this.formTarget.requestSubmit === "function") {
        this.formTarget.requestSubmit(submitButton || undefined);
      } else {
        this.formTarget.submit();
      }
    } else {
      console.error("Comment form target not found.");
    }
  }
}